import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

import Maintenance from '@ui/components/Maintenance.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...routes,
    {
      component: Maintenance,
      name: 'maintenance',
      path: '/maintenance',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    // @ts-ignore
    to.name !== 'maintenance' &&
    (process.env.STUUT_MAINTENANCE_MODE?.toLowerCase() === 'true' ||
      process.env.STUUT_MAINTENANCE_MODE === '1')
  ) {
    // @ts-ignore
    next({ name: 'maintenance' });
  } else {
    next();
  }
});

export default router;
